import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNotification } from '../context/NotificationContext';
import { useI18n } from '../i18n';
import './FloatingNotification.css';

const NotificationItem = ({ notif, onRemove }) => {
  const { t } = useI18n();
  const [inputValue, setInputValue] = useState(notif.defaultValue || '');

  const handlePromptSubmit = () => {
    if (notif.onSubmit) notif.onSubmit(inputValue);
    onRemove(notif.id);
  };

  const handleCancel = () => {
    if (notif.onCancel) notif.onCancel();
    onRemove(notif.id);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handlePromptSubmit();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  const isInteractive = notif.type === 'confirm' || notif.type === 'prompt';

  return (
    <motion.div
      initial={{ opacity: 0, y: -20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
      layout
      className={`notification-item ${notif.type}`}
      onClick={() => !isInteractive && onRemove(notif.id)}
    >
      <div className="notification-content">
        <div className="notification-message">{notif.message}</div>

        {notif.type === 'confirm' && (
          <div className="notification-actions">
            <button
              className="notif-btn confirm"
              onClick={(e) => {
                e.stopPropagation();
                if (notif.onConfirm) notif.onConfirm();
                onRemove(notif.id);
              }}
            >
              {t('common.yes')}
            </button>
            <button
              className="notif-btn cancel"
              onClick={(e) => {
                e.stopPropagation();
                if (notif.onCancel) notif.onCancel();
                onRemove(notif.id);
              }}
            >
              {t('common.no')}
            </button>
          </div>
        )}

        {notif.type === 'prompt' && (
          <div className="notification-prompt-container">
            <input
              type="text"
              className="notif-prompt-input"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
              onClick={(e) => e.stopPropagation()}
            />
            <div className="notification-actions">
              <button className="notif-btn confirm" onClick={handlePromptSubmit}>{t('common.confirm')}</button>
              <button className="notif-btn cancel" onClick={handleCancel}>{t('common.cancel')}</button>
            </div>
          </div>
        )}
      </div>
      {!isInteractive && <div className="notification-progress" />}
    </motion.div>
  );
};

const FloatingNotification = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <div className="notification-container">
      <AnimatePresence>
        {notifications.map((notif) => (
          <NotificationItem
            key={notif.id}
            notif={notif}
            onRemove={removeNotification}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FloatingNotification;
